export  const comissionHandler = (soldValue) => {
    if(!soldValue || soldValue < 0){
        return 0
    }
    if(soldValue < 500){
        const comissionTax = 0.25
        const totalComission = soldValue * comissionTax
        return totalComission
    }
    if(soldValue < 1000){
        const comissionTax = 0.30
        const totalComission = soldValue * comissionTax
        return totalComission
    }
    if(soldValue < 1500){
        const comissionTax = 0.35
        const totalComission = soldValue * comissionTax
        return totalComission
    } 
    const comissionTax = 0.40
    const totalComission = soldValue * comissionTax
    return totalComission
}